import React from "react";
import ChangeCard from "./ChangeCard"; // your existing component
import SectionHeading from "./text/SectionHeading";
import { GSCQueryTable } from "./GSCQueryTable";

type MetricChange = {
  value: number;
  changeFromPrev: { abs: number; pct: number };
  changeFromLastYear: { abs: number; pct: number };
};

type GSCRow = {
  query: string;
  page: string;
  country: string;
  device: string;
  clicks: MetricChange;
  impressions: MetricChange;
  ctr: MetricChange;
  position: MetricChange;
};

interface GSCDashboardProps {
  data: GSCRow[];
}

export const GSCMetricsCards: React.FC<GSCDashboardProps> = ({ data }) => {
  if (!data) {
    return "<p>Google Search Console data was unavailable. Please try again or contact support.</p>";
  }
  // Aggregate top-level KPIs
  const totalClicks = data.reduce((sum, row) => sum + row.clicks.value, 0);
  const totalImpressions = data.reduce(
    (sum, row) => sum + row.impressions.value,
    0
  );
  const avgCtr = totalClicks / totalImpressions;
  const avgPosition =
    data.reduce((sum, row) => sum + row.position.value, 0) / data.length;

  const prevClicks = data.reduce(
    (sum, row) => sum + row.clicks.value - row.clicks.changeFromPrev.abs,
    0
  );
  const lastYearClicks = data.reduce(
    (sum, row) => sum + row.clicks.value - row.clicks.changeFromLastYear.abs,
    0
  );

  return (
    <div className="rounded-lg border bg-card p-4 shadow-sm xl:col-span-2 my-4">
      <SectionHeading
        title="Google Search Console"
        subtitle="See how you site has ranked on Google"
      />{" "}
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <ChangeCard
          metric={totalClicks}
          change={
            prevClicks
              ? (((totalClicks - prevClicks) / prevClicks) * 100).toFixed(1) +
                "%"
              : undefined
          }
          yoyChange={
            lastYearClicks
              ? (
                  ((totalClicks - lastYearClicks) / lastYearClicks) *
                  100
                ).toFixed(1) + "%"
              : undefined
          }
          label="Clicks"
          tooltip="Total clicks for selected period"
        />
        <ChangeCard
          metric={totalImpressions}
          label="Impressions"
          tooltip="Total impressions for selected period"
          change={undefined}
          yoyChange={undefined}
        />
        <ChangeCard
          metric={parseFloat((avgCtr * 100).toFixed(1))}
          label="CTR (%)"
          tooltip="Click-through rate"
          change={undefined}
          yoyChange={undefined}
        />
        <ChangeCard
          metric={parseFloat(avgPosition.toFixed(2))}
          label="Avg. Position"
          tooltip="Average search result position"
          change={undefined}
          yoyChange={undefined}
        />
      </div>
      {/* Table of Top Queries/Pages */}
      <GSCQueryTable data={data} />
    </div>
  );
};
